import React, { useEffect, useState } from "react";

import { Alert, Button, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppRoutePath } from "../../../hooks/useReactRouterDom";
import { useWhatsappMessageReceivedSocket } from "../SocketProvider.hooks";

export const WhtasAppMessageAlert = () => {
  const navigate = useNavigate();
  const path = useAppRoutePath();
  const whatsappMessage = useWhatsappMessageReceivedSocket();

  const [openSnackBar, setOpenSnackBar] = useState(false);

  // useEffect(() => {
  // 	if (whatsappMessage?.status === "RECEIVED") setOpenSnackBar(true);
  // }, [whatsappMessage]);

  // const handleViewMessageClick = () => {
  // 	navigate(`leads/manage/${uuid}`);
  // 	setOpenSnackBar(false);
  // };

  if (openSnackBar)
    return (
      <Snackbar
        open={openSnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          width: "100%",
          p: 1,
          left: "0px !important",
          top: "0px !important",
        }}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: "100%", py: 2, background: "#25D366" }}
          action={
            <>
              <Button
                color="inherit"
                size="small"
                sx={{ textTransform: "capitalize" }}
                // onClick={handleViewMessageClick}
              >
                View Message
              </Button>
              <Button
                color="inherit"
                size="small"
                sx={{ textTransform: "capitalize" }}
                onClick={() => setOpenSnackBar(false)}
              >
                Close
              </Button>
            </>
          }
        >
          New WhatsApp Message Received
        </Alert>
      </Snackbar>
    );

  return <></>;
};
